import React from 'react';
import {Helmet} from "react-helmet";
import {useQueryClient} from "@tanstack/react-query";
import {USER_CURRENT_KEY} from "../../../api/public-voissa/users";
import { useLocation, Link } from 'react-router-dom';

import "./HomeFeed.scss";

import {canonical} from "../../../libs/helper";

import {useBreakpoint} from "../../../libs/breakpoint";
import FeedProfilesSuggest from './components/FeedProfilesSuggest';
import HomeFeedDefaultPopular from './HomeFeedDefaultPopular';
import HomeFeedForYou from './HomeFeedForYou';
import HomeFeedMostRecent from './HomeFeedMostRecent';
import classNames from 'classnames';

const TAB = {
    DISCOVER : <HomeFeedDefaultPopular/>,
    FOR_YOU : <HomeFeedForYou/>,
    RECENT : <HomeFeedMostRecent/>,
}

const HomeFeed = () =>{
    const breakpoints = useBreakpoint();
    const queryClient = useQueryClient();
    const userIsConnected = !!queryClient.getQueryData([USER_CURRENT_KEY]);
    const defaultTab = userIsConnected ? 'FOR_YOU' : 'DISCOVER';
    const location = useLocation();
    const hash = location.hash;
    let currentTab;
    switch (hash) {
        case '#suivis':
            currentTab = 'FOR_YOU';
            break;
        case '#decouvrir':
            currentTab = 'DISCOVER';
            break;
        case '#plus-recents':
            currentTab = 'RECENT';
            break;
        default:
            currentTab = defaultTab;
    }
    const feedTabRender = TAB[currentTab] || TAB['DISCOVER'];
    return (
        <div id="HomeFeed">
            <Helmet>
                <title>Voissa, l'épanouissement par l'exhibition et le sexe</title>
                <meta name="description"
                      content={"Voissa est une source d'épanouissement à travers l'exhibition, le partage et la sensualité. Envoyez vos contributions photos ou vidéos amateurs, créez un blog coquin public ou privé, rencontrez et réalisez de belles expériences avec les Voissanautes."}/>
                <meta name="keywords"
                      content={"voissa, sexe amateur, video amateur, video sexe amateur, amateur sexe"}/>
                <link rel="canonical" href={canonical("", "", "home")} />
            </Helmet>
            <div className="container">
                <div className='hf-layout'>
                    <div className="hf-main-wrapper">
                        <div className="hf-feed-wrapper">
                            <div className="hf-section-nav-wrapper">
                                {userIsConnected &&  <Link to="#suivis" className={classNames("hf-section-nav", {active : currentTab === 'FOR_YOU'})}>Suivis</Link>}
                                <Link to="#decouvrir" className={classNames("hf-section-nav", {active : currentTab === 'DISCOVER'})}>Découvrir</Link>
                                <Link to="#plus-recents" className={classNames("hf-section-nav", {active : currentTab === 'RECENT'})}>Plus récents</Link>
                            </div>
                            {feedTabRender}
                        </div>
                    </div>
                    {!breakpoints.md && (
                        <div className="hf-side-wrapper">
                            <div className="hf-section-title-wrapper">
                                <span className="hf-section-title">Suggestion de profils</span>
                            </div>
                            <FeedProfilesSuggest/>
                        </div>
                    )}
                </div>
            </div>
            {!userIsConnected && (
                <div className="container">
                    <div className="footer-home">
                        <p>Voissa est né pour permettre à ses membres de trouver un lieu dans lequel ils pourraient
                            discuter, partager et se dévoiler en toute liberté. En 1999 le web débute, peu de sites
                            répondent à cette demande et pourtant Voissa est déjà là, ce petit jardin secret fréquenté
                            par quelques centaines de personnes.</p>

                        <p>Depuis lors Voissa a évolué et bien entendu grossi. Plus de 100 000 personnes viennent
                            désormais quotidiennement profiter de notre communauté, pour se montrer ou simplement
                            regarder, pour discuter, débattre, commenter ou simplement lire.</p>

                        <p>Les années n'ont pas dévié Voissa de son objectif, restant fidèle à son ADN, continuant de
                            faire de sa communauté un lieu ou règne le respect, la bonne humeur et l'envie commune de
                            voir ses membres s'épanouir sexuellement.</p>

                        <p>En vous baladant sur Voissa vous trouverez des photos et vidéos sexuelles. La liberté c'est
                            aussi de permettre à chacun de s'exprimer, qu'il souhaite publier une vidéo <a
                                href="https://www.jacquieetmicheltv.net" target="_blank"
                                rel="noopener noreferrer">porno</a> ou plus sensuelle, chacun utilise son profil comme
                            il l'entend.</p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default HomeFeed